<template>
  <div style="padding: 20px 5px 120px">
    <h3>实名认证服务协议</h3>
    <div>
             实行用户账号实名注册制度，
      防止未成年人过度沉迷网络，倡导健康网络习惯，保护未成年人的身心健康，
      您与本店铺在此特缔结《实名认证服务协议》（以下简称“本协议”），
      本协议具有合同效力。请您务必审慎阅读、充分理解本协议各条款内容，
      特别是免除或者限制责任的条款、法律适用和争议解决条款。前述条款可能以黑体加粗、
      颜色标记或其他合理方式提示您注意，
      您对该等条款的确认将可能导致您在特定情况下的被动、不便、损失，
      请您在确认同意本协议之前或在使用实名认证服务之前再次阅读前述条款。
    </div>

    <div>
             您确认，
      在您使用实名认证服务之前，您已详细阅读了本协议的全部内容，
      您点击同意、接受或下一步，或您开始实名认证流程，
      即表示您已充分理解并同意签署本协议。如果您未满18周岁，
      本平台将权利限制你的消费功能。
    </div>
    <h4>一、关于实名认证服务</h4>
    <div>       1．实名认证服务是由本平台提供的一项身份识别服务。如果您需要使用和享受本平台服务，您需要先注册成为系统用户，并按照国家法律法规的相关要求，对您的系统用户账号进行实名认证。我们会在获得您同意或您主动提供的情况下收集您的实名身份信息，该信息属于敏感信息，拒绝提供实名身份信息可能会导致您无法登陆登录本平台或在使用本平台过程中受到相应的限制。</div>
    <div>       2．在开始实名认证服务前，您应当确保具备中华人民共和国法律规定的与您行为相适应的民事行为能力。如果您未满18周岁，请在法定监护人的陪同下使用实名认证服务。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的后果。</div>
    <div>       3．您进行实名认证时，应提供有关您本人真实、合法、准确、有效的身份信息及其他相关信息，且不得以他人身份资料进行实名注册。否则因此造成的一切后果由您自行承担，且本平台有权要求您赔偿因此给本平台造成的所有损失。</div>
    <div>       4．鉴于现有技术及运营商资源的局限性，在实名认证实施过程中可能存在缺陷及瑕疵，包括但不限于认证不及时、结果不准确等，您对此表示理解和同意。</div>
    <div>       5．您充分理解并同意：为判断或核实您提供的相关实名认证信息是否真实或有效，本平台有权将您提供的实名认证信息提供给第三方进行整理、保存及比对等处理或采取其他必要措施，且本公司会按照法律法规及政策规定、本协议约定，根据您的实名认证信息判断您是否年满18周岁、您提交的实名身份信息是否规范或实名验证是否通过等，或根据您法定监护人的合理要求，从而采取切实有效的措施保护未成年人在使用平台服务过程中的合法权益，包括可能采取技术措施、禁止未成年人接触本平台功能、限制未成年人的使用时间等，预防未成年人沉迷网络。</div>
    <div>       6．您理解并同意，一旦您的用户账号完成了实名认证，相应的身份信息和认证结果将不能自行修改或取消。如果您的实名认证信息在完成认证后发生了变更，您应向本公司提供相应有权部门出具的凭证，由本平台协助您变更您用户账号的对应实名认证信息。</div>
    <div>       7．本实名认证服务目前仅适用于中华人民共和国大陆地区持有效身份证明的个人用户，如非中华人民共和国大陆地区已成年用户请提供其相关证明给与平台，并保证其证明真实有效，不得冒用他人身份资料进行提交。</div>

    <h4>二、用户信息的收集、使用与保护</h4>
    <div>       1.您同意并授权本平台为履行本协议之目的收集您的用户信息，这些信息包括您在实名认证过程中提交的信息、您用户账号下的信息以及其他您在使用系统服务的过程中向本平台提供基于安全、用户体验优化等考虑而需收集的信息，本平台对您的用户信息的收集将遵循本协议及相关法律的规定。</div>
    <div>       2.您充分理解并同意，为了使您享有更便捷的服务，您向本公司提交实名认证申请，即表示您同意本平台为您核对所提交的全部实名认证信息，并同意本平台将是否通过实名认证的结果及相关身份信息提供给该第三方。</div>
    <div>       3.本平台会通过安全的方式存储您的信息，包括本地存储（例如利用APP进行数据缓存）、数据库和服务器日志等，且在为实现服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。当本公司的产品或服务发生停止运营的情况时，我们将根据相关法律法规规定进行公告通知，并依法保障您的合法权益。</div>
    <div>       4.根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得您的授权同意：</div>
    <div>       1） 与国家安全、国防安全直接相关的；</div>
    <div>       2） 与公共安全、公共卫生、重大公共利益直接相关的；</div>
    <div>       3） 与犯罪侦查、起诉、审判和判决执行等直接相关的；</div>
    <div>       4） 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</div>
    <div>       5） 个人信息主体自行向社会公众公开个人信息的；</div>
    <div>       6） 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道</div>
    <div>       7） 法律法规规定的其他情形。</div>
    <div>       5.除法律另有规定外，如您已同意或授权本平台依据前述协议或规定收集、使用或处理涉及您的个人信息的，在您撤回该同意或授权后，不影响本公司在此之前已基于您的同意或授权所进行的个人信息的收集、使用或处理，本公司对此前相关个人信息收集、使用或处理继续有效。</div>
    <div>       6.您充分理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。</div>


    <h4>三、用户行为规范</h4>
    <div>       1．接受本协议全部的说明、条款、条件是您申请认证的先决条件。您声明并保证，您不得为任何非法或为本协议、条件及须知所禁止之目的进行实名认证申请。您不得以任何可能损害、使瘫痪、使过度负荷或损害其他网站或其他网站的服务或本平台或干扰他人对于用户实名认证申请的使用等方式使用实名认证服务。您不得经由非本平台许可提供的任何方式取得或试图取得任何资料或信息。</div>
    <div>       2．您应妥善保管好您的账户、密码及相关实名认证信息，若您未尽上述义务，或由于黑客攻击、计算机病毒侵入或发作、电信部门技术调整导致之影响、因政府管制而造成的暂时性关闭、第三方原因（包括不可抗力，例如国际出口的主干线路及国际出口电信提供商一方出现故障、火灾、水灾、雷击、地震、洪水、台风、龙卷风、火山爆发、瘟疫和传染病流行、罢工、战争或暴力行为或类似事件等）等非因本平台的过错导致账号密码遗失、账号被盗、个人资料泄露等情形，本平台将不承担相关法律责任。</div>
    <div>       3．您充分理解并同意，本平台有权依合理判断对违反有关法律法规或本协议规定的行为进行处理，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应独自承担由此而产生的一切法律责任。因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；本平台因此遭受损失的，您也应当一并赔偿。</div>
    <h4>四、管辖与法律适用</h4>
    <div>       1．本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</div>
    <div>       2．因本协议发生的任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交至本平台有管辖权的人民法院管辖。</div>
    <h4>五、其他</h4>
    <div>       1．本平台有权在必要时修改或变更本协议内容，并通过网站公告或其他可以收悉的方式公告变更后的协议文本。本协议进行任何修改或变更后，您还继续使用平台服务和/或实名认证服务的，即代表您已阅读、了解并同意接受变更后的协议内容。</div>
    <div>       2．本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</div>
    <div>       3．本协议条款无论因何种原因部分无效，其余条款仍有效，对各方具有约束力。</div>

    <div class="return" @click="back">
      <van-icon name="arrow-left" size="16px"/>
      <div>返回</div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import { Icon } from 'vant'

Vue.use(Icon);

export default {
  name: "Agreement",

  methods:{
    back(){
      this.$router.back(-1)
    }
  },
}
</script>

<style scoped>
  div{
    line-height: 28px;
  }

  .return{
    position: fixed;
    bottom: 50px;
    left: 50px;
    display: flex;
    align-items: center;
    border-radius: 50%;
    background: deepskyblue;
    padding: 10px 4px 10px 0 ;
    color: #fff;
  }
</style>